<template>
  <div class="app-header" :class="{ 'app-header--images': routes.includes(path) }">
    <div class="app-header_body">
      <div class="item-lefts">
        <router-link to="/">视频首页</router-link>
        <router-link to="/pager">试卷中心</router-link>
        <router-link to="/user">个人中心</router-link>
      </div>
      <div class="item-rights">
        <span v-if="getUser == null" @click="bandleLogin">登录系统</span>
        <!-- <router-link to="/login" v-if="user == null">登录系统</router-link> -->
        <div class="user_box" v-else>

          <img src="@/assets/images/img_user.jpg" alt="">
          <span>{{ getUser.userRealName }}</span>
          <span @click="bandleLogout">退出登录</span>
          <span v-if="getUser.isAdmin == 1" @click="enterAdministratorPage">进入后台管理系统</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getUser, removeUser } from "../../utils/auth";
// import { logout } from "@/api/login";
import { resetRouter } from '@/router'
import { mapMutations } from 'vuex';
import { toLink } from '@/utils/index';
import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter
export default {
  data() {
    return {
      // user: getUser(),
      routes: ['Video'],
      path: this.$route.name
    }
  },
  watch: {
    '$route'(to) {
      this.path = to.name;
    }
  },
  computed: {
    getUser() {
      return this.$store.getters.getUserInfo;
    },
  },
  methods: {
    ...mapMutations('permission', ['SET_HAS_ROUTE']),
    // bandleLogout() {
    //   logout().then(res => {
    //     if (res.code == 0) {
    //       // alert('前台修改hasRoute')
    //       this.SET_HAS_ROUTE(false);
    //       removeUser();
    //       resetRouter()
    //       this.user = null;
    //       this.$router.replace({
    //         path: '/redirect/'
    //       });
    //     }
    //   })
    // },
    bandleLogin() {
      toLink();
    },
    bandleLogout() {
      this.SET_HAS_ROUTE(false);
      resetRouter()
      this.$store.dispatch('longOut');
    },
    enterAdministratorPage() {
      // alert('进入后台')
      // console.log('header-index.vue getUser:',this.getUser)
      if (this.getUser.roles[0].code == 'root' || this.getUser.roles[0].code == 'admin') {
        this.$router.replace('/admin/').catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
            Promise.reject(e)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  height: 60px;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  font-size: 16px;
  z-index: 999;
}

.app-header--images {
  background: url("~@/assets/images/headbg-s.png") no-repeat center;
}

.app-header_body {
  height: 100%;
  width: 1100px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #0c0c0c;
  padding: 0 15px;

  span {
    cursor: pointer;
  }

  .item-lefts {
    a {
      margin-right: 35px;
      color: #0c0c0c;
    }

    a.router-link-exact-active {
      font-weight: bold;
    }
  }
}

.user_box {
  display: flex;
  align-items: center;
  color: #0c0c0c;

  img {
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }

  span {
    cursor: pointer;
    margin-left: 20px;
  }
}
</style>